import React, { Component } from 'react';
import { OauthSender } from 'react-oauth-flow';
import btnTrello from '../assets/button_trello_connection.svg'

class TrelloAcceptComponent extends Component {

    constructor(props) {
        super(props);
        this.state = { token: "", current_path: "", current_token: "" }
    }

    componentDidMount() {
        let current_path = window.location.origin + window.location.pathname;
        const urlParams = window.location.hash.split('=')
        if (urlParams[0] === "#token") {
            localStorage.setItem('token', urlParams[1]);
            this.setState({ token: urlParams[1] })
        }

        this.setState({ current_path: current_path, current_token: localStorage.getItem('token') });
    }

    render() {
        const { current_path, current_token } = this.state
        return (
            <>
                <div hidden={!current_token}>
                    <button className="btn-trello-2">
                        <img className="img-trello" src={btnTrello} alt="trello" />
                        Connecté Trello</button>
                </div>
                <div hidden={current_token}>
                    <OauthSender
                        authorizeUrl="https://trello.com/1/authorize?expiration=never&scope=read,write&response_type=token&name=ZideeUp&key=0f801328c5eb1a3e5afd86b655b17534"
                        clientId={"0f801328c5eb1a3e5afd86b655b17534"}
                        redirectUri={current_path}
                        state={{ from: '/settings' }}
                        render={({ url }) => <a href={url}><button className="btn-trello">
                            <img className="img-trello" src={btnTrello}
                                alt="trello" />
                            Connecter Trello</button></a>}
                    />
                </div>
            </>
        );
    }
}







export default TrelloAcceptComponent;